import React from "react";
import Lottie from "react-lottie";
import { SpringValue } from "react-spring";
import styled from "styled-components";

import { mapConfig } from "../../utils/map-utils/map-config";
import { Button } from "../shared/Button";
import Text from "../shared/Text";
import { LoadingContext } from "../../contexts/LoadingContent";

const animationData = require("./lottie/cartouche.json");

interface CartoucheProps {
  scale: SpringValue<number>;
  zoom: (by: number) => void;
}
const IntroCartouche: React.FC<CartoucheProps> = (props) => {
  const [showContinue, setShowContinue] = React.useState(true);
  const [{ isReady, isCartoucheComplete }, setLoading] = React.useContext(
    LoadingContext
  );

  const handleContinue = React.useCallback(() => {
    setShowContinue(false);
    const currentScale = props.scale.getValue();

    props.zoom(-(currentScale / mapConfig.zoom.min));
  }, [props]);

  return (
    <Wrapper className="intro-cartouche">
      <NoTouching>
        <Lottie
          width={1000}
          height={900}
          isPaused={!isReady}
          speed={2}
          eventListeners={[
            {
              eventName: "complete",
              callback: () =>
                setLoading({
                  pinsLoaded: true,
                  backgroundLoaded: true,
                  error: null,
                  isReady: true,
                  isCartoucheComplete: true,
                }),
            },
          ]}
          options={{
            loop: false,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
              progressiveLoad: false,
            },

            animationData,
          }}
        />
      </NoTouching>
      <MapIntro className={isCartoucheComplete ? "active" : "hidden"}>
        <Text as="p">
          Explore our musical map and experience the history of England through its songs and stories.
        </Text>
        {showContinue && <Button onClick={handleContinue}>Continue</Button>}
      </MapIntro>
    </Wrapper>
  );
};

const NoTouching = styled.div`
  pointer-events: none;
`;
const Wrapper = styled.div`
  position: absolute;
  top: calc(
    -2700px + (${window.innerHeight * (1 / mapConfig.zoom.default)}px / 2)
  );
  left: calc(
    1000px + (${window.innerWidth * (1 / mapConfig.zoom.default)}px / 2)
  );
  mix-blend-mode: multiply;
  /* background: url("/boxes/6000/cartouche-border.jpg"); */
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: flex-end;
  user-select: none;
  /* padding: 13rem 13rem; */

  user-select: none;
  background-size: contain;
  background-repeat: no-repeat;
  transform: translate(-50%, -50%);
  background-position: center;
  p {
    font-size: 2rem;
    line-height: 2.1rem;
    padding-bottom: 2rem;
  }
  button {
    font-size: 1.1rem;
    border-width: 3px;
    font-weight: 600;
  }
`;

const MapIntro = styled.div`
  opacity: 0;
  transform: translateY(0);
  transition: all ease-in-out 0.3s;
  pointer-events: none;
  position: absolute;
  top: 50%;
  width: 750px;
  &.active {
    opacity: 1;
    pointer-events: all;
    transform: translateY(-40px);
  }
`;
export default IntroCartouche;
